import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative w-full py-16 md:py-20 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20dark%20cinema%20theater%20interior%20with%20warm%20golden%20stage%20lights%2C%20elegant%20red%20velvet%20curtains%2C%20dramatic%20atmosphere%2C%20empty%20seats%20with%20soft%20lighting%2C%20cinematic%20mood%2C%20luxurious%20theater%20design&width=1920&height=600&seq=cta-cinema&orientation=landscape"
        alt="八戒电影网观影体验"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/85 via-black/70 to-black/85" />
      <div className="relative w-full px-4 md:px-6">
        <div className="max-w-2xl mx-auto text-center">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-white mb-3">
            准备好享受极致观影体验了吗？
          </h2>
          <p className="text-white/70 text-sm mb-8">
            加入八戒电影网，海量高清影片等你发现，不缓冲流畅播放，开启你的专属影院
          </p>
          <Link
            to="/category/kehuan"
            className="inline-flex items-center gap-2 px-10 py-3.5 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-play-circle-line text-lg"></i>
            立即开始观影
          </Link>
        </div>
      </div>
    </section>
  );
}